import type { Story } from '@/types'
import { hasKey, isObject, isString } from '@/utils/checkers'

/*
 * Common: Authentication with Session Tokens
 */

export type MessageToPluginValidated = {
  action: 'validated'
  token: string
}

/*
 * Tool
 */

export type ToolMessageToPlugin =
  | MessageToPluginValidated
  | {
      action: 'get-context'
      story: Story
      language: string
    }

export const isToolMessageToPlugin = (
  data: unknown,
): data is ToolMessageToPlugin => true

export type ToolMessageToBridge =
  | {
      action: 'tool-changed'
      event: 'heightChange'
      tool: string
      height: number
    }
  | {
      action: 'tool-changed'
      event: 'getContext'
      tool: string
    }
  | {
      action: 'tool-changed'
      event: 'validate'
      tool: string
    }
  | {
      action: 'tool-changed'
      event: 'beginOAuth'
      tool: string
      redirectTo: string
    }
  | {
      action: 'content-changed'
      event: 'reloadPreview'
      tool: string
    }

export const isToolMessageToBridge = (
  data: unknown,
): data is ToolMessageToBridge =>
  isObject(data) &&
  hasKey(data, 'action') &&
  isString(data.action) &&
  ['tool-changed', 'content-changed'].includes(data.action) &&
  hasKey(data, 'event') &&
  isString(data.event) &&
  hasKey(data, 'tool') &&
  isString(data.tool) &&
  [
    'beginOAuth',
    'getContext',
    'heightChange',
    'reloadPreview',
    'validate',
  ].includes(data.event)

/*
 * App
 */

export type AppMessageToPlugin = MessageToPluginValidated

export const isAppMessageToPlugin = (
  data: unknown,
): data is AppMessageToPlugin => true

export type AppMessageToBridge =
  | {
      action: 'app-changed'
      event: 'validate'
    }
  | {
      action: 'app-changed'
      event: 'beginOAuth'
      redirectTo: string
    }

export const isAppMessageToBridge = (
  data: unknown,
): data is AppMessageToBridge =>
  isObject(data) &&
  hasKey(data, 'action') &&
  data.action === 'app-changed' &&
  hasKey(data, 'event') &&
  (data.event === 'validate' || data.event === 'beginOAuth')
